import React, { useEffect, useState, useRef, createRef } from 'react';
import PropTypes from 'prop-types';
import FullScreenDialog from "./../../../PopUp/FullScreendialogs"
import { Button } from '@mui/material';
import axios from 'axios'
import { genURL, gengetURLTEST } from "../../../_getjson.js";

export default function Withholding(props) {
    const { parm } = props
    // const { APCode, APName, table } = props
    const [listitem, setListitem] = useState(parm.withholding)
    const [WHRow1, setWHRow1] = useState("");
    const [col2, setcol2] = useState("");
    const [openFullScreenDialog, setopenFullScreenDialog] = useState(false);
    const [titleFullScreenDialog, settitleFullScreenDialog] = useState("");
    const [typeFullScreenDialog, settypeFullScreenDialog] = useState("");
    const [dataMultipletax, setdataMultipletax] = useState("");
    const [rowid, setrowid] = useState("");
    useEffect(() => {
        componentdidmount()
    }, [])
    const componentdidmount = () => {
        console.log('withholdingparm', parm);
        if (parm.withholding.length > 0) {
            // setListitem(parm.withholding)
            console.log("parm.withholding", parm.withholding);
            setTimeout(async () => {
                let sumTax = 0
                for (let index = 0; index < parm.withholding.length && parm.withholding[index].Taxinvoice; index++) {
                    // if (parm.withholding[index].Tax !== "") {
                    sumTax += await Number(parm.withholding[index].Tax ? parm.withholding[index].Tax : 0)
                    // }
                }
                if (sumTax) {
                    console.log(sumTax);
                    let data = {
                        sumTax: await parseFloat(sumTax).toFixed(2),
                        listitem: listitem
                    }
                    props.sumdata('Withholding', await data)
                }

            }, 200);
        } else {
            let item = []
            for (let index = 0; index < 30; index++) {
                item[index] = {
                    numrow: index + 1,
                    Taxinvoice: "",
                    Invoicedate: "",
                    PayableName: "",
                    PayableName: '',
                    Taxrate: "",
                    Amountbeforetax: "",
                    Tax: "",
                }
                setListitem(item)
            }
        }
    }
    const onRowClick = (data, col, id) => {
        setWHRow1(id);
        setcol2(false);
        if (col === 1) {
            if (!data.PayableName) {
                listitem[id].Invoicedate = Moment(new Date()).format('YYYY-MM-DD')
                listitem[id].PayableName = parm.APCode
                listitem[id].PayableName = parm.APName
                listitem[id].Condition = '1'
            }
        }
        if (data.Taxinvoice) {
            setcol2(true);
            data.btn_C3 = 0
            data.btn_income = 0
            data.btn_type = 0
            data.btn_C4 = 0
            if (col === 2) {
                data.btn_income = 1
                data.Income = data.Incomecode
            }
            if (col === 6) {
                data.btn_C3 = 1
            }
            if (col === 14) {
                data.btn_type = 1
                data.WithholdingType = data.WithholdingTypecode
            }
            if (col === 16) {
                data.btn_C4 = 1

            }
        } else {
            data.btn_C3 = 0
            data.btn_income = 0
            data.btn_type = 0
            data.btn_C4 = 0
        }

    }
    const onAfterSaveCell = (row, cellName, cellValue) => {
        for (let index = 0; index < listitem.length; index++) {
            if (listitem[index].Taxinvoice === "") {
                listitem[index].Income = ""
                listitem[index].Incomecode = ""
                listitem[index].Invoicedate = ""
                listitem[index].PayableName = ""
                listitem[index].Remark = ""
                listitem[index].Taxrate = ""
                listitem[index].Amountbeforetax = ""
                listitem[index].Tax = ""
                listitem[index].WithholdingTypecode = ""
                listitem[index].WithholdingType = ""
                listitem[index].PayableCode = ""
                listitem[index].Condition = ''
            }
        }
        let id = row.numrow - 1
        if (cellName === 'WithholdingType' && row.WithholdingType) {
            var url = "CSWTAXTYPE/Search?Code=" + row.WithholdingType
            console.log(genURL(url));
            axios.get(genURL(url), { timeout: 60000 }).then(async (res) => {
                if (res.data.length > 0) {
                    for (var i = 0; i < res.data.length; i++) {
                        listitem[id].WithholdingTypecode = await res.data[i].CODE
                        listitem[id].WithholdingType = await res.data[i].MYNAMETH
                    }
                } else {
                    listitem[id].WithholdingTypecode = await ""
                    listitem[id].WithholdingType = await ""
                }
                setListitem([...listitem])
            })
        }
        if (cellName === 'Income' && row.Income) {
            var url = "CSINCOMETYPE/Search?Code=" + row.Income
            console.log(genURL(url));
            axios.get(genURL(url), { timeout: 60000 }).then(async (res) => {
                if (res.data.length > 0) {
                    for (var i = 0; i < res.data.length; i++) {
                        listitem[id].Incomecode = await res.data[i].CODE
                        listitem[id].Income = await res.data[i].MYNAMETH
                        listitem[id].Taxrate = await res.data[i].WTAXRATE
                    }
                } else {
                    listitem[id].Incomecode = await ""
                    listitem[id].Income = await ""
                    listitem[id].Taxrate = await ""
                }
                setListitem([...listitem])
            })
        }
        if (cellName === 'Amountbeforetax') {
            if (listitem[id].Taxinvoice) {
                console.log(cellValue);
                let res = (Number(listitem[id].Taxrate) / 100) * Number(cellValue)
                console.log(res);
                row.Tax = parseFloat(res).toFixed(2)
            }
        }
        setTimeout(() => {
            SumCalculate()
        }, 50);

    }
    const onBeforeSaveCell = (row, cellName, cellValue) => {

    }
    const SumCalculate = async () => {
        let sumTax = 0.00
        for (let index = 0; index < listitem.length && listitem[index].Taxinvoice; index++) {
            if (listitem[index].Tax) {
                sumTax += await Number(listitem[index].Tax)
            }
        }
        let data = {
            sumTax: parseFloat(sumTax).toFixed(2),
            listitem: listitem
        }
        console.log("SumCalculate", data);
        props.sumdata('Withholding', data)
    }
    function _cellButton1(cell, row) {
        var btn = row.btn_income;
        var btnShow = <i className=""></i>;
        if (btn) {
            btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => Switch_OtherPopup1('Incometype', row.numrow, "บันทึกภาษีถูกหัก ณ ที่จ่าย")} >
                <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
            </div>;
        }
        return (<div>{btnShow}</div>);
    }
    function _cellButton2(cell, row) {
        var btn = row.btn_C3;
        var btnShow = "";
        switch (btn) {
            case 1:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => Switch_OtherPopup1('Apcode', row.numrow, "ค้นหาเจ้าหนี้/ตัวแทนจำหน่าย-AP")} >
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>;
                break;
            case 2:
                btnShow = <i className=""></i>;
                break;
        }
        return (<div>{btnShow}</div>);
    }
    function _cellButton3(cell, row) {
        var btn = row.btn_type;
        var btnShow = <i className=""></i>;
        if (btn) {
            btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => Switch_OtherPopup1('taxtype', row.numrow, "เลือกรายการ")} >
                <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
            </div>;
        }
        return (<div>{btnShow}</div>);
    }
    function _cellButton4(cell, row) {
        var btn = row.btn_C4;
        var btnShow = <i className=""></i>;
        if (btn) {
            btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => Switch_OtherPopup1('Apcode1', row.numrow, "ค้นหาเจ้าหนี้/ตัวแทนจำหน่าย-AP")} >
                <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
            </div>;
        }
        return (<div>{btnShow}</div>);
    }
    const Switch_OtherPopup1 = (type, row, dialog) => {
        setrowid(row)
        let pram = { type: type }
        setdataMultipletax(pram)
        setopenFullScreenDialog(true)
        settitleFullScreenDialog(dialog)
        settypeFullScreenDialog(type)
    };

    const CloseDialog = (e) => {
        setopenFullScreenDialog(e)
    }
    const ReturnData = (e) => {
        console.log(e);
        if (e) {
            let data = e[1].split('|')
            let id = rowid - 1
            if (typeFullScreenDialog === 'Incometype') {
                listitem[id].Incomecode = data[0]
                listitem[id].Income = data[1]
                listitem[id].Taxrate = data[2]
            }
            if (typeFullScreenDialog === 'Apcode') {
                listitem[id].PayableName = data[0]
                listitem[id].PayableName = data[1]
            }
            if (typeFullScreenDialog === 'taxtype') {
                listitem[id].WithholdingTypecode = data[0]
                listitem[id].WithholdingType = data[1]
            }
            if (typeFullScreenDialog === 'Apcode1') {
                listitem[id].PayableCode = data[0]
            }
            // if (typeFullScreenDialog === 'Groupdataall') {
            //     Docgroupcode.current.value = data[0]
            //     Docgroup.current.value = data[1]
            //     setDocgrouptxt(data[1]);
            // }
        }
    }
    return (
        <>

            <FullScreenDialog open={openFullScreenDialog} title={titleFullScreenDialog} type={typeFullScreenDialog} parm={dataMultipletax}
                closeDialog={e => CloseDialog(e)}
                resData={e => ReturnData(e)}
            // type เป็นชื่อ Components subDialog ใช้เป็นเงือนไขในการเปิด subDialog
            />
            <BootstrapTable
                data={listitem}
                options={{
                    onRowClick: onRowClick,
                    noDataText: "ไม่พบข้อมูล"
                }}
                height='550'
                cellEdit={{ //แก้ไข
                    mode: 'click',
                    blurToSave: true,
                    beforeSaveCell: onBeforeSaveCell,//ก่อนเปลี่ยนค่า
                    afterSaveCell: onAfterSaveCell,//หลังเปลี่ยนค่า 
                }} >
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="40" dataField='numrow' isKey> </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" width="150" dataField='Taxinvoice' editable={false} > เลขที่ </TableHeaderColumn>
                <TableHeaderColumn row="0" colSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" /* className="colbuttomhidden" */ width="170"> <div align="center"> ประเภทเงินได้ </div> </TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="Income" editable={col2} dataAlign="center" width="140"></TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="btn_income" editable={false} dataAlign="center" width="30" dataFormat={_cellButton1} columnClassName="columnClassNameFormat1"></TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" hidden dataField='Incomecode'></TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" editable={{ type: 'date' }} className="columnNumber" dataAlign="left" width="120" dataField='Invoicedate'> ลงวันที่ </TableHeaderColumn>
                <TableHeaderColumn row="0" colSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" /* className="colbuttomhidden" */ width="170"> <div align="center"> รหัสเจ้าหนี้ </div> </TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="PayableName" editable={col2} dataAlign="center" width="140"></TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="btn_C3" editable={false} dataAlign="center" width="30" dataFormat={_cellButton2} columnClassName="columnClassNameFormat1"></TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="left" width="200" dataField='PayableName' editable={col2} > ชื่อผู้ขาย / ผู้ให้บริการ </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" width="140" dataField='Remark'> หมายเหตุ </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" width="140" dataField='Taxrate'> อัตราภาษี </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="left" width="120" dataField='Amountbeforetax'> ยอดก่อนภาษี </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="left" width="200" dataField='Tax' editable={false}> ภาษี</TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" hidden dataField='WithholdingTypecode'></TableHeaderColumn>
                <TableHeaderColumn row="0" colSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" /* className="colbuttomhidden" */ width="170"> <div align="center"> ประเภท </div> </TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="WithholdingType" editable={col2} dataAlign="center" width="140"></TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="btn_type" editable={false} dataAlign="center" width="30" dataFormat={_cellButton3} columnClassName="columnClassNameFormat1"></TableHeaderColumn>
                <TableHeaderColumn row="0" colSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" /* className="colbuttomhidden" */ width="170"> <div align="center"> กระทำการแทน </div> </TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="PayableCode" editable={col2} dataAlign="center" width="140"></TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="btn_C4" editable={false} dataAlign="center" width="30" dataFormat={_cellButton4} columnClassName="columnClassNameFormat1"></TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" width="140" dataField='Condition'  > เงื่อนไข </TableHeaderColumn>
            </BootstrapTable>
        </>
    )
}
Withholding.prototype = {
    parm: PropTypes.array
} 